import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem"; 
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";  

const menus = [
    {
        id: 11,
        title: 'About Us',
        link: '/about',
    },
    {
        id: 12,
        title: 'Pricing',
        link: '/pricing',
    },
    {
        id: 13,
        title: 'Free Tools',
        submenu: [  
            { title: 'Break-even Occupancy Calculator', link: 'https://easemyhotel.io/break-even-occupancy-calculator.html' },
            { title: 'OTA Commission Leakage', link: 'https://easemyhotel.io/ota-commission-leakage-direct-booking-roi-calculator.html' },
            { title: 'RevPAR / ADR / Occupancy Calculator', link: 'https://easemyhotel.io/revpar-adr-occupancy-calculator.html' },
            { title: 'Food Cost % + Menu Engineering Tool', link: 'https://easemyhotel.io/food-cost-menu-engineering-tool.html' }
        ]
    },
    {
        id: 14,
        title: 'Contact Us',
        link: '/contact',
    }
];

const MobileMenu = () => {
    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo({ top: 0, left: 10, behavior: 'smooth' });  // ✅ Modern scrollTo
    };

    const toggleSubmenu = (id) => {
        setOpenId(openId === id ? 0 : id);
    };

    return (
        <List className="main_menu_list" disablePadding>  {/* ✅ Use List as container */}
            {menus.map((item) => (  // ✅ Use item.id as key
                <Fragment key={item.id}>
                    <ListItem disablePadding>
                        {item.submenu ? (
                            <Fragment>
                                <ListItemButton 
                                    onClick={() => toggleSubmenu(item.id)}
                                    selected={item.id === openId}
                                >
                                    <ListItemText primary={item.title} />
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                </ListItemButton>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {item.submenu.map((submenu, i) => (
                                            <a href={submenu.link}>{submenu.title}</a>
                                        ))}
                                    </List>
                                </Collapse>
                            </Fragment>
                        ) : (
                            <ListItemButton 
                                component={Link} 
                                to={item.link}
                                onClick={ClickHandler}
                            >
                                <ListItemText primary={item.title} />
                            </ListItemButton>
                        )}
                    </ListItem>
                </Fragment>
            ))}
        </List>
    );
};

export default MobileMenu;
